<template>
	<div>
		<div class="row">
			<div class="col-lg-4">
				<label for="">Factor Descuento Material</label>
				<input type="text" class="form-control" v-model="FactorDescuentoMaterial">
			</div>
			<div class="col-lg-4">
				<label for="">Factor Descuento Refaccion</label>
				<input type="text" class="form-control" v-model="FactorDescuentoRefaccion">
			</div>
			<div class="col-lg-4">
				<label for="">Factor Descuento Equipo</label>
				<input type="text" class="form-control" v-model="FactorDescuentoEquipo">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'clientes',
	props:["poBtnSave"],
	data() {
		return {
			FactorDescuentoMaterial:0,
			FactorDescuentoRefaccion:0,
			FactorDescuentoEquipo:0,
			IdSucursal:0,
			Modal:true,
			FormName:'clientes',
			EmitSeccion:this.poBtnSave.EmitSeccion,
		}
	},
	methods: {
		async Guardar(){
			this.poBtnSave.toast = 0;
			let formData=new FormData();
			formData.set('IdSucursal',this.IdSucursal);
			formData.set('FactorDescuentoMaterial',this.FactorDescuentoMaterial);
			formData.set('FactorDescuentoRefaccion',this.FactorDescuentoRefaccion);
			formData.set('FactorDescuentoEquipo',this.FactorDescuentoEquipo);
			await this.$http.post('sucursalxdistribuidor/update',formData).then((res)=>{
				this.poBtnSave.disableBtn = false;
				this.poBtnSave.toast = 1;
				this.bus.$emit('List');
				$('#cliente').modal('hide');
			});
		},
		Recuperar(){
			this.$http.get('sucursalxdistribuidor/getone',{
				params:{
					IdSucursal:this.IdSucursal
				}
			}).then((res)=>{
				this.FactorDescuentoMaterial=res.data.data.FactorDescuentoMaterial;
				this.FactorDescuentoRefaccion=res.data.data.FactorDescuentoRefaccion;
				this.FactorDescuentoEquipo=res.data.data.FactorDescuentoEquipo;
			})
		},
		Limpiar(){
			this.IdSucursal=0;
			this.FactorDescuentoMaterial=0;
			this.FactorDescuentoEquipo=0;
			this.FactorDescuentoRefaccion=0;
		}
	},
	created() {
		this.bus.$off('NewModal_'+this.EmitSeccion);
		this.bus.$on('NewModal_'+this.EmitSeccion,(IdSucursal)=>{
			this.Limpiar();
			this.IdSucursal=IdSucursal;
			this.Recuperar();
			this.bus.$off('Save_'+this.EmitSeccion);
			this.bus.$on('Save_'+this.EmitSeccion,()=>{
				this.Guardar();
			});
		});
	},
}
</script>

<style>

</style>
